import { Component, Input, OnInit } from '@angular/core';
import { User } from 'src/app/classes';

@Component({
  selector: 'app-user-preview2',
  templateUrl: './user-preview2.component.html',
  styleUrls: ['./user-preview2.component.css']
})
export class UserPreviewComponent2 implements OnInit {

  name: string;
  eMail: string;
  hasProfilePicture: boolean;
  initials: string;
  profilePictureData: string;

  _user: User;
  @Input() set user(user: User){
    this._user = user;
    if(user){
      this.name = user.userName;
      this.eMail = user.email;
      if(user.profilePicture && user.profilePictureMediaType){
        this.hasProfilePicture = true;
        this.profilePictureData = "data:" + user.profilePictureMediaType + ";base64," + user.profilePicture;
      } else {
        this.hasProfilePicture = false;
        this.profilePictureData = null;
      }
      this.initials = user.initials;
    } else {
      this.name = "unnamed user";
      this.eMail = null;
      this.hasProfilePicture = false;
      this.initials = null;
      this.profilePictureData = null;
    }
  }
  get user(): User {
    return this._user;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
